import clsx from 'clsx'
import { useState } from 'react'

import catalogSortStyles from '@/features/catalog/catalog-sort/ui/catalog-sort.module.scss'
import { MobileSort } from '@/features/catalog/catalog-sort/ui/mobile-sort/mobile-sort'

import { Radio, Select } from '@/shared/ui'
import { Checkbox } from '@/shared/ui/checkbox'
import type { Option } from '@/shared/ui/Selector/types/types'
import { MobileSelect, MobileSelectTrigger } from '@/shared/ui/Selector/ui/mobile-select/mobile-select'

import { REVIEW_SORT_FILTER_OPTIONS, ReviewSortFilterMode } from '../../model/constants'
import { Stars } from '../stars/Stars'

import styles from './ReviewFilters.module.scss'

const RATING_FILTER_OPTIONS: Option[] = [
	{ value: 'all', label: 'Все звезды' },
	{ value: '5', label: '5 звезд', content: <Stars rating={5} /> },
	{ value: '4', label: '4 звезды', content: <Stars rating={4} /> },
	{ value: '3', label: '3 звезды', content: <Stars rating={3} /> },
	{ value: '2', label: '2 звезды', content: <Stars rating={2} /> },
	{ value: '1', label: '1 звезда', content: <Stars rating={1} /> }
]
const RATING_SELECT_OPTIONS = RATING_FILTER_OPTIONS.slice(1)

const SORT_FILTER_LABEL = 'Сортировка'
const RATING_FILTER_LABEL = 'Рейтинг'

type ReviewFiltersProps = {
	sortValue: ReviewSortFilterMode
	ratingValue: string[]
	onSortChange: (value: ReviewSortFilterMode) => void
	onRatingChange: (value: number[]) => void
}

export const ReviewFilters = ({ sortValue, ratingValue, onSortChange, onRatingChange }: ReviewFiltersProps) => {
	const [isRatingSheetOpen, setIsRatingSheetOpen] = useState(false)
	const handleRatingChange = (value: string | string[]) => {
		const nextValue = Array.isArray(value) ? value : value ? [value] : []
		if (nextValue.length === 0 && ratingValue.length === 0) return

		onRatingChange(nextValue.map(Number))
	}

	return (
		<>
			<div className={clsx(styles.controls, styles.desktopControls)}>
				<Select
					className={clsx(styles.sortSelect, catalogSortStyles.sort)}
					triggerLabel={SORT_FILTER_LABEL}
					options={REVIEW_SORT_FILTER_OPTIONS}
					value={sortValue}
					onChange={value => onSortChange(value as ReviewSortFilterMode)}
					renderOption={(option, onSelect) => (
						<button type="button" className={styles.ratingSelectOption} onClick={onSelect}>
							<span>{option.label}</span>
							<Radio
								className={styles.filterRadio}
								checked={option.value === sortValue}
								onChange={() => undefined}
								tabIndex={-1}
							/>
						</button>
					)}
				/>
				<Select
					className={clsx(styles.ratingSelect, catalogSortStyles.sort)}
					triggerLabel={RATING_FILTER_LABEL}
					options={RATING_FILTER_OPTIONS}
					renderOption={option => {
						const optionValue = option.value ?? option.label
						const isResetOption = optionValue === 'all'
						const isSelected = isResetOption ? ratingValue.length === 0 : ratingValue.includes(optionValue)

						return (
							<button
								type="button"
								className={styles.ratingSelectOption}
								onClick={() =>
									handleRatingChange(
										isResetOption
											? []
											: isSelected
											? ratingValue.filter(value => value !== optionValue)
											: [...ratingValue, optionValue]
									)
								}>
								<span>{option.content ?? option.label}</span>
								<Checkbox
									className={styles.filterCheckbox}
									checked={isSelected}
									onChange={() => undefined}
									tabIndex={-1}
								/>
							</button>
						)
					}}
				/>
			</div>
			<div className={clsx(styles.controls, styles.mobileControls)}>
				<MobileSort
					triggerLabel={SORT_FILTER_LABEL}
					selectionStyle="radio"
					variant="outlined"
					className={styles.mobileFilterTrigger}
					options={REVIEW_SORT_FILTER_OPTIONS}
					value={sortValue}
					onChange={onSortChange}
				/>
				<MobileSelectTrigger
					variant="outlined"
					className={styles.mobileFilterTrigger}
					label={RATING_FILTER_LABEL}
					onClick={() => setIsRatingSheetOpen(true)}
				/>
			</div>
			<MobileSelect
				title={RATING_FILTER_LABEL}
				options={RATING_SELECT_OPTIONS}
				value={ratingValue}
				isOpen={isRatingSheetOpen}
				onClose={() => setIsRatingSheetOpen(false)}
				onChange={handleRatingChange}
				resetLabel="Выбрать все"
			/>
		</>
	)
}
